<template>
 <div :class="windowClass">
    <v-row no-gutters>
            <v-col xs="12" class="pa-2">
                

                    <v-card class="pa-2">
                        <v-card-title>
                        <v-icon large left color="secondary">mdi-account-multiple</v-icon> MANAGE CUSTOMERS  
                        <v-spacer></v-spacer>
                        <v-spacer></v-spacer>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            @change="search2=''"
                            single-line
                            hide-details
                        ></v-text-field>
                        <v-icon right color="success" class="mt-5 ml-10" large @click="customer={}, state='new', form=true">mdi-plus-box</v-icon> 
                        </v-card-title>

                        <v-row no-gutters class="mb-4"> 
                          <span style="margin-top: 7px; margin-right: 20px;">FILTERS: </span>
                          <span style="width: 150px; margin-right: 12px;">
                          <v-select
                          dense
                          v-model="search_status"
                            single-line
                            label=""
                            :items="['Active', 'Deactivated']"
                            hide-details
                          >
                          </v-select>
                        </span>
                        <span style="width: 150px;">
                          <v-select
                          v-model="search2"
                          dense
                            single-line
                            label="Customer Type"
                            :items="['Cash Only', 'Credit Only']"
                            hide-details
                          >
                          </v-select>
                        </span>
                        </v-row> 

                             <v-data-table
                                class="va-table"
                                dense
                                :headers="headers"
                                :items-per-page="25"
                                :search="search"
                                :items="FILTERCUSTOMERS"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                           <td>
                                         <v-icon small left color="warning"  @click="customer=item, state='update', form=true">mdi-pencil</v-icon>
                                          {{ item.id }}</td>
                                          <td>{{ item.email }}</td>
                                          <td>{{ item.firstname }}</td>
                                           <td>{{ item.address }}</td>
                                            <td>{{ item.contact_no }}</td>
                                          <td>{{ item.parent_name }}</td>
                                          <td>
                                            <v-icon small color="green" text-color="white" v-if="item.evat == 'enabled'">mdi-check</v-icon>
                                            <v-icon small color="#999" text-color="white" v-else>mdi-times</v-icon>
                                            </td>
                                            <td class="text-xs-center">
                                              
                                            <v-icon small color="green" text-color="white" v-if="item.credit == 'enabled'">mdi-check</v-icon>
                                            <v-icon small color="#999" text-color="white" v-else>mdi-times</v-icon>
                                            </td>
                                    </tr>
                                    </tbody>
                                </template>
                                </v-data-table>
                    </v-card>
            </v-col>
    </v-row>
    <va-customer-form :show="form" :customer="customer" :customerlist="customers" :state="state" @DialogEvent="formEvent" />
  </div>
</template>
<script>
// import { id } from 'vuetify/lib/locale'
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
        form: false,
        state: 'new',
        search2: "Credit Only",
        search_status:"Active",
        customer: {},
        search:'',
        customers:[],
        headers: [
          { text: 'ID', sortable: false},
          { text: 'ACCT No.', value: 'firstname', width:'100px'},
          { text: 'Name', value: 'firstname', width:'300px'},
           { text: 'Address', sortable: false},
          { text: 'Contact No.', sortable: false},
          { text: 'Parent', sortable: false},
          { text: 'Evat', sortable: false },
          { text: 'Credit' , sortable: false}
      ],
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true) 
          this.getItems()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
      FILTERCUSTOMERS() {
        var items  = this.customers.reduce((res, item)=>{
          if(item.status) {
            if(this.search_status == "Active") {
              if(item.status.toLowerCase() == 'active') {
                res.push(item)
              }
            } else {
              if(item.status.toLowerCase() != 'active') {
                res.push(item)
              }
            }
          }
          return res
        }, [])
        return this.filterTypes(items)
      }
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      filterTypes(items){
        var res = items.reduce((res, item)=>{
          if(this.search2 == "Cash Only") {
              if(item.credit != "enabled") {
                res.push(item)
              }
          } else {
            if(item.credit == "enabled") {
                res.push(item)
              }
          }
          return res
        },[])
        return res
      },
      formEvent(data){
          this.form = false
          if(data.action != 'close') {
              this.customer = data.customer
              this.Save()
          }
          console.log(data)
      },
      getItems: function() { 
        this.$http.post("customer/list", JSON.stringify({})).then(response => {
            response.data.data != null?this.customers = response.data.data:this.customers=[]
          }).catch(e => {
           console.log(e.data)
         })
     },
      Save: function() {
        let method = 'customer/new'
        this.state != 'new'?method='customer/update':method = 'customer/new'
        this.customer.firstname = this.customer.firstname.trim()
        this.$http.post(method, JSON.stringify(this.customer)).then(response => {
            response.data.status? this.setAlertColor('success'): this.setAlertColor('error')
            this.setAlertText(response.data.message)
            this.setAlert(true)
            this.getItems()
        }).catch(e => {
        console.log(e)
        })
     },
    }
  }
</script>